import { Box, Typography, TextField, Button, CircularProgress } from "@mui/material";
import Nav from "components/coloque/Nav";
import { useTheme, useMediaQuery } from '@mui/material';
import { useState } from "react";
import ContactEvent from "../../assets/ContactEvent.png";
import ContactPhone from "../../assets/contact_phone.png";
import ContactLocalisation from "../../assets/ContactLocalisation.png";
import ContactCalendar from "../../assets/ContactCalendar.png";
import ContactMessage from "../../assets/ContactMessage.png";
import Footer from "components/coloque/Footer";
import { useSendContactFormMutation } from "../../state/api"; // Adjust path as necessary

const Contact = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    
    // RTK Mutation for sending data
    const [sendContactForm] = useSendContactFormMutation();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        setSuccess(false);

        try {
            // Replace startDate and endDate with appropriate values or formData properties if applicable
            const response = await sendContactForm({
                startDate: formData.startDate,
                endDate: formData.endDate,
                name: formData.name,
                email: formData.email,
                subject: formData.subject,
                message: formData.message,
            }).unwrap();

            if (response) {
                setSuccess(true);
            } else {
                throw new Error("Failed to send message.");
            }
        } catch (error) {
            setError("An error occurred while sending the message. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box>
            <Nav bg={'black'} />
            <Box
                style={{
                    paddingTop: isMobile ? "8em" : "12em",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    textAlign: 'center',
                }}
            >
                <Typography sx={{ fontSize: isMobile ? "34px" : "auto" }} variant="h1" style={{ fontWeight: 'bold', color: "black" }}>
                    Contacter Nous
                </Typography>
            </Box>

            {/* Contact Section */}
            <Box display="flex" justifyContent="center" alignItems="center" flexDirection={isMobile ? "column" : "row"} p={4} gap={0} sx={{ mx: { xs: 0, sm: 4 } }}>
                {/* Image Section */}
                <Box flex="1" style={{ height: '100%', display: "flex", justifyContent: "center" }}>
                    <img src={ContactEvent} alt="Event" style={{ width: '65%', height: 'auto', borderRadius: '8px', objectFit: 'cover' }} />
                </Box>

                {/* Contact Form */}
                <Box component="form" onSubmit={handleSubmit} flex="1" p={3} style={{ backgroundColor: '#f9f9f9', borderRadius: '8px', height: '100%' }}>
                    <Typography variant="h6" style={{ color: 'black', marginBottom: '1em' }}>
                        CONTACT US
                    </Typography>
                    <Typography variant="h2" style={{ fontWeight: 'bold', color: 'black', marginBottom: '1em' }}>
                        Get More Information
                    </Typography>
                    <TextField
                        fullWidth
                        label="Your Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        variant="outlined"
                        margin="normal"
                        InputLabelProps={{
                            style: { color: 'black' },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#000',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#000',
                                },
                            },
                            '& .Mui-focused': {
                                color: 'black',
                            },
                        }}
                    />
                    <TextField
                        fullWidth
                        label="Your Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        variant="outlined"
                        margin="normal"
                        InputLabelProps={{
                            style: { color: 'black' },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#000',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#000',
                                },
                            },
                            '& .Mui-focused': {
                                color: 'black',
                            },
                        }}
                    />
                    <TextField
                        fullWidth
                        label="Your Subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        variant="outlined"
                        margin="normal"
                        InputLabelProps={{
                            style: { color: 'black' },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#000',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#000',
                                },
                            },
                            '& .Mui-focused': {
                                color: 'black',
                            },
                        }}
                    />
                    <TextField
                        fullWidth
                        label="Your Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        variant="outlined"
                        multiline
                        rows={4}
                        margin="normal"
                        InputLabelProps={{
                            style: { color: 'black' },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#000',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#000',
                                },
                            },
                            '& .Mui-focused': {
                                color: 'black',
                            },
                        }}
                    />
                    {error && (
                        <Typography color="error" sx={{ mb: 2 }}>
                            {error}
                        </Typography>
                    )}
                    <Button type="submit" variant="contained" style={{ backgroundColor: '#000', color: "white", marginTop: '1em' }}>
                        {isLoading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : success ? "Message Sent!" : "SEND MESSAGE"}
                    </Button>
                </Box>
            </Box>

            {/* Contact Info Section */}
            <Box
                display="flex"
                justifyContent="center"
                p={4}
                textAlign="center"
                gap={4}
                flexDirection={isMobile ? "column" : "row"}
                flexWrap={isMobile ? "wrap" : "nowrap"}
            >
                {/* Contact Details */}
                <Box sx={{
                    display: "flex",
                    gap: ".5em",
                    alignItems: "center",
                    width: isMobile ? "50%" : "auto",
                }}>
                    <Box>
                        <img src={ContactPhone} alt="Phone number" />
                    </Box>
                    <Box>
                        <Typography variant="body1" sx={{ width: "200px", textAlign: "center" }}><strong>Phone Number</strong></Typography>
                        <Typography variant="body2" sx={{ width: "200px", textAlign: "center" }}>(+621) 115-559</Typography>
                    </Box>
                </Box>

                {/* Location */}
                <Box sx={{
                    display: "flex",
                    gap: ".5em",
                    alignItems: "center",
                    width: isMobile ? "50%" : "auto",
                }}>
                    <Box>
                        <img src={ContactLocalisation} alt="Location" />
                    </Box>
                    <Box>
                        <Typography variant="body1" sx={{ width: "200px", textAlign: "center" }}><strong>Location</strong></Typography>
                        <Typography variant="body2" sx={{ width: "200px", textAlign: "center" }}>Nusa Dua, Bali - Indonesia</Typography>
                    </Box>
                </Box>

                {/* Event Date */}
                <Box sx={{
                    display: "flex",
                    gap: ".5em",
                    alignItems: "center",
                    width: isMobile ? "50%" : "auto",
                }}>
                    <Box>
                        <img src={ContactCalendar} alt="Event Date" />
                    </Box>
                    <Box>
                        <Typography variant="body1" sx={{ width: "200px", textAlign: "center" }}><strong>Event Date</strong></Typography>
                        <Typography variant="body2" sx={{ width: "200px", textAlign: "center" }}>November 14 - 16, 2022</Typography>
                    </Box>
                </Box>

                {/* Email */}
                <Box sx={{
                    display: "flex",
                    gap: ".5em",
                    alignItems: "center",
                    width: isMobile ? "50%" : "auto",
                }}>
                    <Box>
                        <img src={ContactMessage} alt="Email Us" />
                    </Box>
                    <Box>
                        <Typography variant="body1" sx={{ width: "200px", textAlign: "center" }}><strong>Email Us</strong></Typography>
                        <Typography variant="body2" sx={{ width: "200px", textAlign: "center" }}>contact@transitionnumeriquedz.com</Typography>
                    </Box>
                </Box>
            </Box>

            {/* Map Section */}
            <Box display="flex" justifyContent="center" p={4}>
                <iframe
                    title="Event Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3195.755193743891!2d3.04832857564403!3d36.77643987225396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128fb250ed2c2957%3A0xf54d6adcd3a4bafb!2sH%C3%B4tel%20El%20Aurassi!5e0!3m2!1sfr!2sdz!4v1730992920124!5m2!1sfr!2sdz"
                    width={isMobile ? "95%" : "80%"}
                    height="450"
                    style={{ border: '0', borderRadius: '8px' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </Box>

            {/* Footer Section */}
            <Footer marginTop={'2em'} />
        </Box>
    );
}

export default Contact;
